export const FINAL_FIELDS = [
	'final_price',
	'final_esp',
	'freeze_final_prices',
	'review_check_cm',
	'review_comment_pricing',
	'review_comment_cm',
	'review_price_proposal',
	'review_done_pricing',
]
